import { Component, Inject, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export function uniqueName(value: string, names: string[]) {
  if (!value) {
    return null;
  }

  const exists = names.some(name => name.toLowerCase() === value.toLowerCase());
  return exists ? { existingName: { value: value } } : null;
}

@Component({
  selector: 'create-group-dialog',
  templateUrl: './create-group-dialog.component.html',
  styleUrls: ['./create-group-dialog.component.scss'],
})
export class CreateGroupDialogComponent implements OnInit {
  groupName: FormControl;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder,
    private dialogRef: MatDialogRef<CreateGroupDialogComponent>,
  ) {}

  ngOnInit() {
    this.groupName = this.formBuilder.control('', [
      Validators.required,
      (control: AbstractControl) => uniqueName(control.value.trim(), this.data.names),
    ]);
  }

  submit() {
    if (this.groupName.valid) {
      this.dialogRef.close(this.groupName.value.trim());
    }
  }
}
